import { render, staticRenderFns } from "./WarehouseSelector.vue?vue&type=template&id=5034f810&scoped=true"
import script from "./WarehouseSelector.vue?vue&type=script&lang=js"
export * from "./WarehouseSelector.vue?vue&type=script&lang=js"
import style0 from "./WarehouseSelector.vue?vue&type=style&index=0&id=5034f810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034f810",
  null
  
)

export default component.exports